// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipContainer {
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.tooltip-box {
  background: #ffffff;
  border: 1px solid #F5F5F5;
  color: #414651;
  padding: 0.5em 1em;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transform-origin: 50% 100%;
  margin-bottom: 0.75em;
  white-space: normal;
  border-radius: 8px;
  font-size: 12px;
  text-transform: none;
  font-weight: 400;
  min-width: 76px;
  text-align: center;
  z-index: 1033;
  max-width: 240px;
  word-break: break-word;
  box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1), 0 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: max-content;
}
.tooltip-box:before,
.tooltip-box:after {
  content: "";
  position: absolute;
  border: 0.5em solid transparent;
  display: block;
  top: 100%;
  left: 50%;
  margin-left: -0.5em;
}
.tooltip-box:before {
  width: 12px;
  height: 6px;
  border-top-color: #ffffff;
  z-index: 1034;
}
.tooltip-box:after {
  width: 13px;
  height: 11px;
  border-top-color: #F5F5F5;
  z-index: 1034;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/Tooltip/index.less"],"names":[],"mappings":"AAEA;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;ACDJ;ADIA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,2BAAA;EACA,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uFAAA;EACA,kBAAA;ACFJ;ADKA;;EAEI,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;ACHJ;ADMA;EACI,WAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;ACJJ;ADSA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;ACPJ;AACA,oCAAoC","sourcesContent":["@import '../../../less/variables.less';\n\n.tooltipContainer {\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n}\n\n.tooltip-box {\n    background: @white;\n    border: 1px solid @secondary-50;\n    color: @fg-secondary;\n    padding: 0.5em 1em;\n    position: absolute;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    transform-origin: 50% 100%;\n    margin-bottom: 0.75em;\n    white-space: normal;\n    border-radius: @radius-md;\n    font-size: 12px;\n    text-transform: none;\n    font-weight: @font-weight-normal;\n    min-width: 76px;\n    text-align: center;\n    z-index: @tooltip-z-index;\n    max-width: 240px;\n    word-break: break-word;\n    box-shadow: @box-shadow-md;\n    width: max-content;\n}\n\n.tooltip-box:before,\n.tooltip-box:after {\n    content: \"\";\n    position: absolute;\n    border: 0.5em solid transparent;\n    display: block;\n    top: 100%;\n    left: 50%;\n    margin-left: -0.5em;\n}\n\n.tooltip-box:before {\n    width: 12px;\n    height: 6px;\n    border-top-color: @white;\n    z-index: @tooltip-z-index + 1;\n\n}\n\n\n.tooltip-box:after {\n    width: 13px;\n    height: 11px;\n    border-top-color: @secondary-50;\n    z-index: @tooltip-z-index + 1;\n}",".tooltipContainer {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n.tooltip-box {\n  background: #ffffff;\n  border: 1px solid #F5F5F5;\n  color: #414651;\n  padding: 0.5em 1em;\n  position: absolute;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  transform-origin: 50% 100%;\n  margin-bottom: 0.75em;\n  white-space: normal;\n  border-radius: 8px;\n  font-size: 12px;\n  text-transform: none;\n  font-weight: 400;\n  min-width: 76px;\n  text-align: center;\n  z-index: 1033;\n  max-width: 240px;\n  word-break: break-word;\n  box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1), 0 2px 4px -2px rgba(16, 24, 40, 0.06);\n  width: max-content;\n}\n.tooltip-box:before,\n.tooltip-box:after {\n  content: \"\";\n  position: absolute;\n  border: 0.5em solid transparent;\n  display: block;\n  top: 100%;\n  left: 50%;\n  margin-left: -0.5em;\n}\n.tooltip-box:before {\n  width: 12px;\n  height: 6px;\n  border-top-color: #ffffff;\n  z-index: 1034;\n}\n.tooltip-box:after {\n  width: 13px;\n  height: 11px;\n  border-top-color: #F5F5F5;\n  z-index: 1034;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
